import {useContext, useState} from "react";
import {Form} from "antd";
import {useTranslation} from "react-i18next";
import FormContext from "@/app/context/FormContext";
import Input from "@/app/components/form-fields/input/Input";
import GoogleButton from "@/app/components/buttons/google-button/GoogleButton";
import Checkbox from "@/app/components/form-fields/checkbox/Checkbox";
import RoundedButton from "@/app/components/buttons/rounded-button/RoundedButton";
import classes from "../../page.module.scss";
import {EyeInvisibleOutlined, EyeTwoTone} from "@ant-design/icons";
import {registerService} from "@/app/services/RegisterService";
import {
    namePattern, passwordUppercasePattern, passwordNumberPattern, passwordSpecialCharPattern, passwordNoSpacesPattern
} from '@/app/utils/regexPatterns';

const FirstStepForm = () => {
    const {t} = useTranslation();
    const {firstStep, setFirstStep, next} = useContext(FormContext);
    const [serverErrors, setServerErrors] = useState({});

    const onFinish = async (values) => {
        try {
            await registerService.checkEmailAvailability(values.email);
            setFirstStep(values);
            next();
        } catch (error) {
            if (error.response && error.response.data && error.response.data.errors) {
                setServerErrors(error.response.data.errors);
            } else {
            }
        }
    };
    // const gmailValidation = (_, value) => {
    //     if (value && !value.endsWith("@gmail.com")) {
    //         return Promise.reject(new Error(t("validation.gmailOnly")));
    //     }
    //     return Promise.resolve();
    // };

    return (<>
            <Form
                initialValues={firstStep}
                onFinish={onFinish}
            >
                <Form.Item
                    name="name"
                    rules={[{
                        validator: (_, value) => {
                            if (!value.trim() || value.trim().length < 2) {
                                return Promise.reject(new Error(t("validation.nameLength")));
                            }
                            return Promise.resolve();
                        }
                    }, {
                        max: 100,
                    }, {
                        required: true, whitespace: true, message: t('validation.nameRequired'),
                    }, {
                        pattern: namePattern, message: t('validation.namePattern'),
                    },]}
                >
                    <Input
                        placeholder={t('placeholders.nameAndSurname')}
                    />
                </Form.Item>

                <Form.Item
                    name="email"
                    rules={[{
                        required: true, message: t('validation.emailRequired'),
                    }, {
                        type: "email",
                        message: t('validation.emailFormat'),
                    },
                        // {
                        //     validator: gmailValidation,
                        // },

                    ]}
                    help={serverErrors.email ? serverErrors.email[0] : undefined}
                    validateStatus={serverErrors.email ? 'error' : undefined}
                >
                    <Input  onChange={() => setServerErrors((prev) => ({ ...prev, email: null }))}  placeholder={t('placeholders.email')}/>
                </Form.Item>

                <Form.Item
                    name="password"
                    rules={[{
                        required: true, message: t('validation.passwordRequired'),
                    }, {
                        min: 8, max: 128, message: t('validation.passwordLength'),
                    }, {
                        pattern: passwordUppercasePattern, message: t('validation.passwordUppercase'),
                    }, {
                        pattern: passwordNumberPattern, message: t('validation.passwordNumber'),
                    }, {
                        pattern: passwordSpecialCharPattern, message: t('validation.passwordSpecialChar'),
                    }, {
                        pattern: passwordNoSpacesPattern, message: t('validation.passwordSpaces'),
                    },]}
                >
                    <Input
                        type="password"
                        placeholder={t('placeholders.password')}
                        iconRender={(visible) => (visible ? <EyeTwoTone/> : <EyeInvisibleOutlined/>)}
                    />
                </Form.Item>

                <Form.Item
                    name="password_confirmation"
                    dependencies={['password']}
                    rules={[{
                        required: true, message: t('validation.passwordConfirmation'),

                    }, ({getFieldValue}) => ({
                        validator(_, value) {
                            if (!value || getFieldValue('password') === value) {
                                return Promise.resolve()
                            }
                            return Promise.reject(t('validation.passwordConfirmationMatch'))
                        }
                    })]}
                >
                    <Input
                        type="password"
                        placeholder={t('placeholders.confirmPassword')}
                    />
                </Form.Item>
                <div className={classes.checkbox}>
                    <Form.Item
                        valuePropName="checked"
                        name="terms_of_service"
                        rules={[{
                            validator: (_, value) => value ? Promise.resolve() : Promise.reject(new Error(t('validation.checkboxRequired'))),
                        },]}
                    >
                        <Checkbox checked={firstStep.terms_of_service} onChange={e =>  setFirstStep({ ...firstStep, terms_of_service: e.target.checked })}
                                  className={classes.checkbox_text}>{t('payment.checkboxText')}
                        <a href={'https://seekintro-api.amplitudo.me/terms_of_use.pdf'} target={'_blank'} className={classes.checkboxLink}> {t('payment.paymentTerms')}</a> and
                            <a href={'https://api.seekintro.com/privacy-policy.html'} target={'_blank'} className={classes.checkboxLink}> {t('payment.privacyPolicyTerms')}</a>
                        </Checkbox>
                    </Form.Item>
                </div>

                <RoundedButton
                    type="primary"
                    htmlType="submit"
                    className={classes.step_button}
                >
                    {t('buttons.nextStep')}
                </RoundedButton>

                <div>
                    <div className={classes.lines}>
                        <div className={classes.line}></div>
                        <div className={classes.text}>{t('registration.lineText')}</div>
                        <div className={classes.line}></div>
                    </div>
                    <GoogleButton/>
                </div>
            </Form>
        </>)
}

export default FirstStepForm;